import React from "react"
import { useSelector } from "react-redux"
import { Row, Col } from "react-bootstrap"

import {
    StoreType,
    createFileName,
} from "client/store"
import {
    PageForm,
    FormGroup,
    Label,
    Input,
    Textarea,
    DivInput,
    Empty,
} from "client/components"

const Details = () => {
    const requirement = useSelector((state: StoreType) => state.ccRequirement.requirementDetails)
    const typeList = useSelector((state: StoreType) => state.ccRequirementType.typeList)
    const priorityList = useSelector((state: StoreType) => state.ccRequirementPriority.priorityList)
    const statusList = useSelector((state: StoreType) => state.ccRequirementStatus.statusList)
    const lang = useSelector((state: StoreType) => state.system.lang)

    const {
        file,
        typeId,
        priorityId,
        statusId,
    } = requirement

    return (
        <PageForm>
            <Row>
                <Col xs={12} md={4}>
                    <FormGroup>
                        <Label>{lang.uniqueId}</Label>
                        <Input type="text" value={requirement.uniqueId} readOnly />
                    </FormGroup>
                </Col>
                <Col xs={12} md={8}>
                    <FormGroup>
                        <Label>{lang.name}</Label>
                        <Input type="text" value={requirement.name} readOnly />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <FormGroup>
                        <Label>{lang.description}</Label>
                        <Textarea value={requirement.description} readOnly />
                    </FormGroup>

                    <FormGroup>
                        <Label>{lang.file}</Label>
                        <DivInput widePadding>
                            { file ? createFileName(file) : <Empty /> }
                        </DivInput>
                    </FormGroup>

                    <FormGroup>
                        <Label>{lang.type}</Label>
                        <Input type="text" value={typeList[typeId] ? typeList[typeId].name : ""} readOnly />
                    </FormGroup>

                    <FormGroup>
                        <Label>{lang.priority}</Label>
                        <Input type="text" value={priorityList[priorityId] ? priorityList[priorityId].name : ""} readOnly />
                    </FormGroup>

                    <FormGroup>
                        <Label>{lang.status}</Label>
                        <Input type="text" value={statusList[statusId] ? statusList[statusId].name : ""} readOnly />
                    </FormGroup>
                </Col>
            </Row>
        </PageForm>
    )
}
export default Details
